export default "__VITE_ASSET__BDLka6IP__"